import React, { useState } from "react";
import { ReactComponent as EditIcon } from "./icon.svg";
import { Controller } from "react-hook-form";
import PhoneNumberInput from "../PhoneNumberInput";

interface IEditableText {
  name: string;
  control: any;
  rules?: any;
  textProps?: any;
  inputClassName?: string;
  error?: any;
  country?: string;
  defaultValue?: string;
  autoFocus?: boolean;
  wrapperClassName?: string;
  icon?: React.ReactNode;
  placeholder?: string;
}

const EditableText = (props: IEditableText) => {
  const [isFocused, setFocused] = useState(false);
  return (
    <div className={`d-flex flex-col ${props.wrapperClassName}`}>
      <Controller
        control={props.control}
        name={props.name}
        rules={props.rules}
        defaultValue={props?.defaultValue}
        render={({ field }) => {
          const { name, ref, value, onChange, onBlur } = field;
          return !isFocused && props.name !== "contact_info" ? (
            <>
              <div className="d-flex align-items-center">
                <input type="text" name={name} ref={ref} hidden />
                <p className="m-0" {...props.textProps}>
                  {value}
                </p>

                <EditIcon
                  className="ml-2"
                  onClick={() => {
                    setFocused(true);
                  }}
                />
              </div>
            </>
          ) : props.name === "contact_info" ? (
            <>
              <PhoneNumberInput
                country={props.country || "us"}
                autoFocus={props.autoFocus}
                icon={props.icon}
                error={Boolean(props.error)}
                placeholder={props.placeholder}
                onChange={(e) => onChange(e)}
                value={value}
                onBlur={() => {
                  if (value !== "") {
                    setFocused(false);
                    onBlur();
                  }
                }}
              />
            </>
          ) : (
            <input
              autoFocus
              className={props.inputClassName}
              name={name}
              ref={ref}
              onChange={onChange}
              value={value}
              onBlur={() => {
                if (value !== "") {
                  setFocused(false);
                  onBlur();
                }
              }}
            />
          );
        }}
      />
      {props.error && (
        <span className="error-helper ml-0">{props.error.message}</span>
      )}
    </div>
  );
};
export default EditableText;
